export default "__VITE_ASSET__DOtKOyix__"